"use client";

import RemotionPlayer from "./RemotionPlayer";
import { SmsApprovalAnimation } from "@/remotion/homepage/SmsApprovalAnimation";

export default function SMSPhone() {
  return (
    <div className="relative">
      <div className="relative w-[320px] max-w-full rounded-[44px] border-[10px] border-ink-950 bg-ink-950 shadow-2xl">
        <div className="absolute left-1/2 top-2 z-20 h-5 w-24 -translate-x-1/2 rounded-full bg-ink-950" />
        <div className="overflow-hidden rounded-[34px] bg-[#f6f6f6]">
          <div className="bg-[#f6f6f6] px-4 pt-10 pb-3 text-center">
            <p className="text-[12px] font-semibold text-ink-900">OneTapReply</p>
            <p className="text-[10px] text-ink-500">iMessage</p>
          </div>

          <RemotionPlayer
            component={SmsApprovalAnimation}
            durationInFrames={330}
            compositionWidth={300}
            compositionHeight={440}
            fps={30}
          />
        </div>
      </div>
    </div>
  );
}
